import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/logo.jpeg';
import { FaHome, FaBook, FaUser, FaSignOutAlt, FaChartLine, FaGraduationCap, FaBell, FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

useEffect(() => {
  const handleScroll = () => {
    setIsScrolled(window.scrollY > 50); // scroll threshold
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);


  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navItems = [
    // { path: '/', label: 'Home', icon: <FaHome className="text-sm" /> },
    // { path: '/exams', label: 'Courses', icon: <FaBook className="text-sm" /> },
    // { path: '/how-to-use', label: 'How to Use', icon: <FaGraduationCap className="text-sm" /> },
    // { path: '/about', label: 'About', icon: <FaGraduationCap className="text-sm" /> },
    // { path: '/contact', label: 'Contact', icon: <FaUser className="text-sm" /> },
  ];

  const userNavItems = [
    { path: '/dashboard', label: 'Dashboard', icon: <FaChartLine className="text-sm" /> },
    { path: '/results', label: 'My Progress', icon: <FaChartLine className="text-sm" /> },
    { path: '/profile', label: 'Profile', icon: <FaUser className="text-sm" /> },
  ];

  return (
    <header
  className={`fixed top-0 left-0 w-full z-50
  transition-all duration-500 ease-in-out
  ${
    isScrolled
      ? 'translate-y-0 opacity-100 visible pointer-events-auto bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-200'
      : '-translate-y-full opacity-0 invisible pointer-events-none bg-transparent'
  }
`}
>

      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3 group">
              <img
                src={logo}
                alt="Stenography Pro Logo"
                className="h-20 w-auto transition-all duration-300 group-hover:scale-105 drop-shadow-sm rounded-lg"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-1">
            {/* Navigation Links */}
            <div className="flex space-x-1 mr-6">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-xl transition-all duration-200 ${
                    isActive(item.path)
                      ? 'text-blue-600 bg-blue-50 border border-blue-200 shadow-sm'
                      : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
                  }`}
                >
                  {item.icon}
                  {item.label}
                </Link>
              ))}
            </div>

            {user ? (
              <div className="flex items-center space-x-4">
                {/* User Menu */}
                <div className="relative">
                  <button
                    onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                    className="flex items-center space-x-3 focus:outline-none group p-2 rounded-xl hover:bg-gray-50 transition-all duration-200"
                  >
                    <div className="h-10 w-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-medium shadow-lg transition-all duration-200 group-hover:scale-105">
                      {user?.name?.charAt(0).toUpperCase()}
                    </div>
                    <div className="text-left">
                      <p className="text-sm font-semibold text-gray-800">{user.name}</p>
                      <p className="text-xs text-gray-500">Student</p>
                    </div>
                    <svg
                      className={`h-4 w-4 text-gray-400 transition-transform duration-200 ${
                        isUserMenuOpen ? 'transform rotate-180' : ''
                      }`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  {isUserMenuOpen && (
                    <div className="absolute right-0 mt-2 w-64 rounded-2xl shadow-xl bg-white border border-gray-200 transform transition-all duration-200 ease-out">
                      <div className="p-4 border-b border-gray-100">
                        <p className="text-sm font-semibold text-gray-800">{user.name}</p>
                        <p className="text-xs text-gray-500">{user.email}</p>
                      </div>
                      <div className="p-2">
                        {userNavItems.map((item) => (
                          <Link
                            key={item.path}
                            to={item.path}
                            onClick={() => setIsUserMenuOpen(false)}
                            className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200"
                          >
                            {item.icon}
                            {item.label}
                          </Link>
                        ))}
                        {user?.email === 'admin.sscsteno@gmail.com' && user.role === 'admin' && (
                          <Link
                            to="/admin-panel"
                            onClick={() => setIsUserMenuOpen(false)}
                            className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors duration-200"
                          >
                            <FaUser className="text-sm" />
                            Admin Panel
                          </Link>
                        )}
                        <button
                          onClick={() => {
                            setIsUserMenuOpen(false);
                            handleLogout();
                          }}
                          className="flex items-center gap-3 w-full px-3 py-3 rounded-lg text-sm text-red-600 hover:bg-red-50 transition-colors duration-200"
                        >
                          <FaSignOutAlt className="text-sm" />
                          Sign Out
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="flex items-center space-x-3">
                <Link
                  to="/login"
                  className="px-6 py-2.5 text-sm font-medium rounded-xl text-gray-600 hover:text-blue-600 hover:bg-gray-50 transition-all duration-200 border border-transparent hover:border-gray-200"
                >
                  Sign In
                </Link>
                <Link
                  to="/register"
                  className="px-6 py-2.5 text-sm font-medium rounded-xl text-white bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                >
                  Start Learning
                </Link>
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-3 rounded-xl text-gray-600 hover:text-blue-600 hover:bg-gray-50 focus:outline-none transition-all duration-200 border border-gray-200"
            >
              {isMenuOpen ? <FaTimes className="h-5 w-5" /> : <FaBars className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className={`${
          isMenuOpen ? 'block' : 'hidden'
        } md:hidden bg-white shadow-xl border-t border-gray-200 transform transition-all duration-200 ease-out`}
      >
        <div className="pt-4 pb-4 space-y-1 px-4">
          {/* Navigation Links */}
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setIsMenuOpen(false)}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl text-base font-medium transition-all duration-200 ${
                isActive(item.path)
                  ? 'text-blue-600 bg-blue-50 border border-blue-200'
                  : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              {item.icon}
              {item.label}
            </Link>
          ))}

          {/* User Specific Links */}
          {user && (
            <div className="pt-4 border-t border-gray-200">
              <p className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                Your Learning
              </p>
              {userNavItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 rounded-xl text-base font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50 transition-colors duration-200"
                >
                  {item.icon}
                  {item.label}
                </Link>
              ))}
              {user?.email === 'admin.sscsteno@gmail.com' && user.role === 'admin' && (
                <Link
                  to="/admin-panel"
                  onClick={() => setIsMenuOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 rounded-xl text-base font-medium text-orange-600 hover:bg-orange-50 transition-colors duration-200"
                >
                  <FaUser className="text-sm" />
                  Admin Panel
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Auth Buttons for Mobile */}
        {!user ? (
          <div className="pt-4 pb-4 border-t border-gray-200 px-4">
            <div className="flex flex-col space-y-3">
              <Link
                to="/login"
                onClick={() => setIsMenuOpen(false)}
                className="text-center px-4 py-3 rounded-xl text-base font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50 transition-all duration-200 border border-gray-200"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                onClick={() => setIsMenuOpen(false)}
                className="text-center px-4 py-3 rounded-xl text-base font-medium text-white bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 shadow-md"
              >
                Start Learning
              </Link>
            </div>
          </div>
        ) : (
          <div className="pt-4 pb-4 border-t border-gray-200 px-4">
            <div className="flex items-center gap-3 px-4 py-3 bg-gray-50 rounded-xl mb-3">
              <div className="h-10 w-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-medium">
                {user?.name?.charAt(0).toUpperCase()}
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800">{user.name}</p>
                <p className="text-xs text-gray-500">Student</p>
              </div>
            </div>
            <button
              onClick={() => {
                setIsMenuOpen(false);
                handleLogout();
              }}
              className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-base font-medium text-red-600 hover:bg-red-50 transition-colors duration-200"
            >
              <FaSignOutAlt className="text-sm" />
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;